import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 9CDA3BD8-77A5-4669-BFB7-785EECAE2FCA
 * name volume-vibrate
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-vibrate.svg
 * tags
 * - Cellphone / Phone 
 * - Audio 
 */
export const VolumeVibrateIcon = createSvgIcon(<><path d="M4 9V15H8L13 20V4L8 9H4M16.55 2.47L15.5 3.53L17.93 6L15 9L17.93 12L15 15L17.93 18L15.5 20.47L16.55 21.53L20 18L17.07 15L20 12L17.07 9L20 6L16.55 2.47Z" /></>, 'VolumeVibrateIcon');
export default VolumeVibrateIcon